export class ShowMoreArticle {
  constructor() {
    this._cards = document.querySelectorAll('[data-show-more-article]');

    this._documentClickHandle = this._documentClickHandle.bind(this);
  }

  init() {
    if (!this._cards.length) {
      return;
    }

    this._initSlides();

    document.addEventListener('click', this._documentClickHandle);
  }

  _initSlides() {
    this._cards.forEach((card) => {
      const text = card.querySelector('[data-show-more-article-text]');
      text.style.height = `${this._height}px`;

      if (this._isElementOverflown(text)) {
        const button = card.querySelector('[data-show-more-article-button]');
        button.classList.add('is-visible');
      }
    });
  }

  _isElementOverflown(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
  }

  _documentClickHandle(evt) {
    const target = evt.target;

    if (!target.closest('[data-show-more-article-button]')) {
      return;
    }

    const card = target.closest('[data-show-more-article]');
    const text = card.querySelector('[data-show-more-article-text]');
    const button = card.querySelector('[data-show-more-article-button]');

    if (window.innerWidth >= 1240) {
      if (card.classList.contains('is-active')) {
        setTimeout(() => {
          card.classList.remove('is-active');
        }, 600);
        text.classList.remove('is-visible');
      } else {
        card.classList.add('is-active');
        setTimeout(() => {
          text.classList.add('is-visible');
        }, 600);
      }
    } else {
      card.classList.toggle('is-active');
      text.classList.toggle('is-visible');
    }

    if (button.textContent === button.dataset.buttonHiddenText) {
      button.textContent = button.dataset.buttonVisibleText;
    } else {
      button.textContent = button.dataset.buttonHiddenText;
    }
  }
}